<script>
import requestFunctions from "@src/functions/requestFunctions";

export default {

    components: { requestFunctions },

    props: {
        attachments: {type: Map, value: {}},
        attaching_uuid: {type: String, value: null},
        attaching_type: {type: String, value: null},
        btn_title: {type: String},
        btn_icn: {type: String},
        multiple: {type: Boolean}
    },

    data() {
        return {
            attach: null,
            attachments_qnt: 0,
            attachmentsShow: false,
        }
    },

    watch: {
        attach: {
            immediate: true,
            handler(values) {
                this.uploadFiles(values);
            }
        },
    },

    computed: {
        attachments_files(){
            let qnt = this.attachments_qnt;
            return this.attachments;
        },
    },

    async mounted() {

    },

    methods: {

        async uploadFiles(values) {

            if (values !== null) {
                this.attachmentsShow = true;

                // Добавляем файлы в массив и отправляем на сервер
                for (const el of values) {

                    // Отправляем файл на бэк
                    let data_send = {
                        title  : el.name,
                        path   : this.$parent.attaching_uuid,
                        status : 'loading',
                        attaching_uuid : this.$parent.attaching_uuid,
                        attaching_type : this.$parent.attaching_type
                    }

                    let new_file;
                    new_file = await this.$store.dispatch('files/FETCH_FILES_CREATE', data_send);

                    this.attachments.set(new_file.uuid, {title:el.name, filename: null, status: 'load'});
                    this.attachments_qnt++;

                    this.endUploadFile(el, new_file.uuid);
                }

                this.$refs['inputFile'].reset();
            }
        },

        async endUploadFile(file, uuid) {

            // Сохраняем файл на сервере
            let data_send = {
                action : 'upload',
                path   : this.$parent.attaching_uuid,
                attaching_type: this.$parent.attaching_type,
                upload_file: file
            }

            let query_url = 'https://api.client.za-bota.com/uploads/';
            let response = await requestFunctions.sendDataAsync(query_url, data_send, 'POST');

            this.attachments.set(uuid, {
                title    : response.title,
                filename : response.name,
                status   : 'success',
                path     : response.path,
                ext      : response.ext,
                uuid     : uuid
            });

            // Обновляем
            data_send = {
                title    : response.title,
                filename : response.name,
                status   : 'success',
                path     : response.path,
                ext      : response.ext,
                uuid     : uuid
            }

            await this.$store.dispatch('files/FETCH_FILES_UPDATE', data_send);

            this.$parent.attachments = this.attachments;

            this.attachments_qnt++;
        },

        async deleteAttachFile(key){

            // Удаляем файл с сервера
            let file;

            file = this.attachments.get(key);

            let data_send = {
                action  : 'delete',
                path    : this.$parent.attaching_uuid,
                attaching_type: this.$parent.attaching_type,
                filename: file.filename
            }

            let query_url = 'https://api.client.za-bota.com/uploads/';
            let response = await requestFunctions.sendDataAsync(query_url, data_send, 'GET');

            data_send = {
                uuid: file.uuid,
            }
            await this.$store.dispatch('files/FETCH_FILES_DELETE', data_send);

            // Удаляем файл из массива
            this.attachments.delete(key);
            this.attachments_qnt--;

            if (this.attachments.size === 0) {
                this.attachmentsShow = false;
            }

            this.$parent.attachments = this.attachments;
        },

        async openFinder(){
            this.$refs.inputFile.$el.childNodes[0].click();
            return false;
        }
    }
}
</script>

<template>
    <div>
        <div class="mt-4">
            <div class="row">
                <div v-for="(item, index) in attachments_files" :key="index" :ref="item[1].title" :class="'attachments_files col-xl-12 col-md-12 ' + item[1].status">
                    <div class="p-2 border rounded mb-2">
                        <div class="media">
                            <div class="avatar-sm font-weight-bold mr-3">
                                <span class="avatar-title rounded bg-soft-primary text-primary">
                                    <i class="uil-file-plus-alt font-size-18"></i>
                                </span>
                            </div>
                            <div class="media-body">
                                <a
                                    :href="'https://api.client.za-bota.com/uploads/files/' + $parent.attaching_type + '/' + $parent.attaching_uuid + '/' + item[1].filename"
                                    class="d-inline-block mt-2"
                                    target="_blank"
                                >{{item[1].title}}</a>
                            </div>
                            <div class="inner_btn float-right mt-1">
                                <span role="status" style="width: 1.5rem; height: 1.5rem;" class="spinner-border text-primary"><span class="sr-only">Loading...</span></span>
                                <a href="javascript: void(0);" @click="deleteAttachFile(item[1].uuid, 'in')" class="p-2">
                                    <i class="uil-trash-alt font-size-18"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <b-form-group
            style="margin-top: 5px"
            v-show="attachments.size == 0"
        >
            <a href="javascript: void(0)" style="cursor: pointer" @click="openFinder('in')" class="btn btn-outline-primary" right>
                <i :class="'uil ' + (btn_icn ? btn_icn : 'uil-paperclip') + ' mr-1'"></i>{{ btn_title ? btn_title : 'Прикрепить файл' }}
            </a>
            <b-form-file
                v-model="attach"
                ref="inputFile"
                style="display: none"
                :multiple="multiple"
            ></b-form-file>
        </b-form-group>
    </div>
</template>

<style>
.attachments_files.success .inner_btn span{
    display: none;
}
.attachments_files.load .inner_btn a {
    display: none;
}
</style>